import { render, staticRenderFns } from "./PointAdd.vue?vue&type=template&id=029726da&scoped=true&"
import script from "./PointAdd.vue?vue&type=script&lang=js&"
export * from "./PointAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029726da",
  null
  
)

export default component.exports